import {
  string,
  object,
  shape,
  number,
} from 'prop-types';

const User = shape({
  access_token: string,
  expiresAt: number,
  id_token: string,
  profile: object,
  refresh_token: string,
  scope: string,
  session_state: string,
  state: string,
  token_type: string,
});

export default User;
